import axios from "axios";
import config from "../../../../config/config";

const TOWNSHIPS_URL = config.baseUrl + "township";
const Slider_Base_Url = config.baseUrl + "vitrin/slider";
const Banner_Base_Url = config.baseUrl + "vitrin/banner";
const Icons_Base_Url = config.baseUrl + "vitrin/Icon";
const Blogs_Base_Url = config.baseUrl + "vitrin/Blog";

export function get_townships() {
  return axios.get(TOWNSHIPS_URL);
}

export function getAllSlider() {
  return axios.get(Slider_Base_Url);
}

export function getAllBanner() {
  return axios.get(Banner_Base_Url);
}

export function getAllIcons() {
  return axios.get(Icons_Base_Url);
}

export function getAllBlogs() {
  return axios.get(Blogs_Base_Url);
}
